module.exports = __webpack_public_path__ + "static/media/21.2ddb719d.jpg";